import React from 'react';
import { withTheme } from 'styled-components';
export var FinanzasIcon = function FinanzasIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "265px",
    height: "265px",
    viewBox: "0 0 265 265",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Finanzas"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Finanzas",
    transform: "translate(-51.000000, -1.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "15"
  }, React.createElement("g", {
    transform: "translate(58.000000, 9.000000)",
    id: "Money-Payments-Finance__x2F__Money__x2F__accounting-coins-stack_2_"
  }, React.createElement("g", null, React.createElement("g", {
    id: "Group_18_2_"
  }, React.createElement("g", {
    id: "accounting-coins-stack_2_"
  }, React.createElement("path", {
    d: "M81.81,43.66 C126.65,43.66 163,33.97 163,22.01 C163,10.05 126.65,0.36 81.81,0.36 C36.97,0.36 0.62,10.05 0.62,22.01 C0.62,33.97 36.97,43.66 81.81,43.66 Z",
    id: "Oval_6_2_"
  }), React.createElement("path", {
    d: "M162.96,22.01 L162.96,54.49 C162.96,66.45 126.62,76.14 81.77,76.14 C36.92,76.14 0.58,66.45 0.58,54.49 L0.58,22.01",
    id: "Shape_157_2_"
  }), React.createElement("path", {
    d: "M162.96,54.49 L162.96,86.97 C162.96,98.93 126.62,108.62 81.77,108.62 C36.92,108.62 0.58,98.93 0.58,86.97 L0.58,54.49",
    id: "Shape_158_2_"
  }), React.createElement("path", {
    d: "M168.42,184.39 C213.26,184.39 249.61,174.7 249.61,162.74 C249.61,150.78 213.26,141.09 168.42,141.09 C123.58,141.09 87.23,150.78 87.23,162.74 C87.23,174.7 123.58,184.39 168.42,184.39 Z",
    id: "Oval_7_2_"
  }), React.createElement("path", {
    d: "M249.57,162.74 L249.57,195.22 C249.57,207.18 213.23,216.87 168.38,216.87 C123.53,216.87 87.19,207.18 87.19,195.22 L87.19,162.74",
    id: "Shape_159_2_"
  }), React.createElement("path", {
    d: "M249.57,195.22 L249.57,227.7 C249.57,239.66 213.23,249.35 168.38,249.35 C123.53,249.35 87.19,239.66 87.19,227.7 L87.19,195.22",
    id: "Shape_160_2_"
  }), React.createElement("path", {
    d: "M162.96,86.96 L162.96,119.44 C162.96,131.4 126.62,141.09 81.77,141.09 C36.92,141.09 0.58,131.4 0.58,119.44 L0.58,86.96",
    id: "Shape_161_2_"
  }), React.createElement("path", {
    d: "M0.58,119.44 L0.58,151.92 C0.58,163.88 36.93,173.57 81.77,173.57 L87.18,173.57",
    id: "Shape_162_2_"
  }), React.createElement("path", {
    d: "M0.58,151.91 L0.58,184.39 C0.58,196.35 36.93,206.04 81.77,206.04 L87.18,206.04",
    id: "Shape_163_2_"
  }), React.createElement("line", {
    x1: "163.01",
    y1: "119.44",
    x2: "163.01",
    y2: "141.09",
    id: "Shape_164_2_"
  }))))))));
};
export default withTheme(FinanzasIcon);